import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { BaseButton } from './BaseButton';
import { useTheme } from '../ThemeProvider/useTheme';
const StyledBaseButton = styled(BaseButton) `
  ${({ disabled, loading, theme }) => !disabled &&
    !loading &&
    `
      color: ${theme.colors.content.above.contrast};
      background: ${theme.colors.interactive.contrast.default};
      border: 0;

      &:hover {
        background: ${theme.colors.interactive.contrast.hover};
      }
    `}
`;
const ContrastButtonComponent = (props, ref) => {
    const theme = useTheme();
    return _jsx(StyledBaseButton, Object.assign({ ref: ref, theme: theme }, props));
};
export const ContrastButton = forwardRef(ContrastButtonComponent);
